import type { ThemeId } from '../theme/ThemeContext'

/** 与各 `data-theme` 配套的 3D 背景（public/login-bg） */
export function loginBackgroundSrc(theme: ThemeId): string {
  return `/login-bg/login-bg-${theme}.png`
}

/**
 * 叠在底图上：不再整屏铺半透明白/灰雾（会冲掉素材饱和度）。
 * 仅保留局部暗角、压边，让中间区域尽量「所见即底图」。
 */
export function loginScrimBackground(theme: ThemeId): string {
  switch (theme) {
    case 'warm':
      return [
        'radial-gradient(ellipse 130% 75% at 50% 100%, rgba(28, 24, 20, 0.38), transparent 58%)',
        'radial-gradient(ellipse 70% 55% at 0% 0%, rgba(40, 32, 26, 0.15), transparent 52%)',
      ].join(', ')
    case 'cool':
      return [
        'radial-gradient(ellipse 125% 80% at 50% 100%, rgba(8, 40, 72, 0.28), transparent 58%)',
        'radial-gradient(ellipse 65% 50% at 100% 0%, rgba(0, 120, 180, 0.1), transparent 50%)',
      ].join(', ')
    case 'dark':
      return [
        'radial-gradient(ellipse 120% 85% at 50% 100%, rgba(0, 0, 0, 0.45), transparent 55%)',
        'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(22, 104, 220, 0.12), transparent 50%)',
      ].join(', ')
    case 'glass':
      return [
        'radial-gradient(ellipse 130% 90% at 50% 100%, rgba(0, 8, 16, 0.55), transparent 58%)',
        'radial-gradient(ellipse 90% 70% at 50% 0%, rgba(0, 188, 212, 0.1), transparent 52%)',
      ].join(', ')
    case 'cartoon':
      return [
        'radial-gradient(ellipse 140% 88% at 50% 100%, rgba(45, 32, 22, 0.4), transparent 56%)',
        'radial-gradient(ellipse 75% 55% at 15% 10%, rgba(92, 64, 51, 0.12), transparent 48%)',
      ].join(', ')
    case 'illustration':
      return [
        'radial-gradient(ellipse 130% 82% at 50% 100%, rgba(48, 40, 36, 0.28), transparent 58%)',
        'radial-gradient(ellipse 70% 50% at 0% 0%, rgba(120, 90, 78, 0.1), transparent 50%)',
      ].join(', ')
    case 'pixel':
      return [
        'radial-gradient(ellipse 125% 85% at 50% 100%, rgba(0, 4, 12, 0.5), transparent 58%)',
        'repeating-linear-gradient(105deg, transparent, transparent 14px, rgba(52, 211, 153, 0.04) 14px, rgba(52, 211, 153, 0.04) 15px)',
      ].join(', ')
    case 'geek':
      return [
        'radial-gradient(ellipse 130% 90% at 50% 100%, rgba(0, 6, 2, 0.48), transparent 58%)',
        'radial-gradient(ellipse 85% 55% at 50% 0%, rgba(45, 156, 77, 0.1), transparent 50%)',
      ].join(', ')
  }
}
